import { CustomAdditionalTextPdpComponent } from './custom-additional-text-pdp.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {CmsConfig, ConfigModule, I18nModule} from '@spartacus/core';

@NgModule({
  declarations: [CustomAdditionalTextPdpComponent],
  imports: [
    CommonModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        AdditionalTextComponent: {
          component: CustomAdditionalTextPdpComponent,
        },
      },
    } as CmsConfig),
  ],
  exports: [CustomAdditionalTextPdpComponent],
})
export class CustomAdditionalTextPdpModule { }
